import { Loader2 } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useAdminFeedbackAnalytics } from "@/lib/api";

import { FeedbackDashboard } from "./feedback-dashboard";

export function AdminFeedbackPage() {
  const analyticsQuery = useAdminFeedbackAnalytics(90);

  const isLoading = analyticsQuery.isLoading;
  const isError = analyticsQuery.isError;

  return (
    <div className="bg-background min-h-screen">
      <header className="border-border flex items-center justify-between border-b px-6 py-4">
        <h1 className="font-heading text-primary text-xl font-bold">Feedback</h1>
        <div className="flex items-center gap-2">
          <Link to="/admin/activity">
            <Button variant="ghost">Activity</Button>
          </Link>
          <Link to="/admin/users">
            <Button variant="ghost">Users</Button>
          </Link>
          <Link to="/home">
            <Button variant="outline">Back</Button>
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">
        {isLoading ? (
          <Card>
            <CardContent className="flex justify-center py-12">
              <Loader2 className="text-muted h-6 w-6 animate-spin" />
            </CardContent>
          </Card>
        ) : isError || !analyticsQuery.data ? (
          <Card>
            <CardContent className="py-8 text-center">
              <p className="text-muted text-sm">
                Could not load feedback. Please{" "}
                <button
                  type="button"
                  onClick={() => {
                    void analyticsQuery.refetch();
                  }}
                  className="underline"
                >
                  try again
                </button>{" "}
                or{" "}
                <Link to="/home" className="underline">
                  go back
                </Link>
                .
              </p>
            </CardContent>
          </Card>
        ) : (
          <FeedbackDashboard analytics={analyticsQuery.data} />
        )}
      </main>
    </div>
  );
}
